import { render } from "./MaintenanceIssueIndex.vue?vue&type=template&id=24fbc0a4"
import script from "./MaintenanceIssueIndex.vue?vue&type=script&lang=js"
export * from "./MaintenanceIssueIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__